import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@tencent/wphk-design';
import { computed } from 'vue';
import dayjs from 'dayjs';
import { BannerStatus } from '../hooks/use-vitasoy-lottery';
import { LICENSE_NUMBER, LOTTERY_BANNER, LOTTERY_START_TIME, PROMOTION_END_TIME } from '../config';

/**
 * Banner 组件 Props
 */
interface LotteryBannerProps {
  /** Banner 状态 (ongoing/ended/won) */
  status?: BannerStatus;
  /** cdkey 是否存在 (1-有, 0-无) */
  hasCdkey?: string;
}

type EmitFn = (e: 'click') => void;

export default /*#__PURE__*/_defineComponent({
  __name: 'lottery-banner',
  props: {
    status: null,
    hasCdkey: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ((e: 'click') => void), expose: any, slots: any, attrs: any }) {

const props = __props as { status?: BannerStatus, hasCdkey?: string }


const licenseNumber = LICENSE_NUMBER;

/**
 * 格式化推广时间文案
 * @returns 格式化的推广时间文案，如：推廣時間：2026年1月14日-2026年2月13日（首尾兩天包括在內）
 */
const getPromotionTimeText = (): string => {
  const startDate = dayjs(LOTTERY_START_TIME).format('YYYY年M月D日');
  const endDate = dayjs(PROMOTION_END_TIME).format('YYYY年M月D日');
  return `推廣時間：${startDate}-${endDate}（首尾兩天包括在內）`;
};

/**
 * 推广时间文案（从配置动态获取）
 */
const promotionTimeText = getPromotionTimeText();
const isEnd = computed(() => props.status === BannerStatus.Ended);
/**
 * 事件定义
 */



/**
 * 按钮文案 (根据状态计算)
 */
const computedButtonText = computed(() => {
  switch (props.status) {
    case BannerStatus.Ended:
      return '已結束';
    case BannerStatus.Won:
      return '我的獎賞';
    default:
      return '立即參與';
  }
});

/**
 * Banner 图片映射
 */
const bannerImage = LOTTERY_BANNER;

/**
 * 按钮点击处理
 */
const onClickButton = () => {
  emit('click');
};

return { __sfc: true,props, licenseNumber, getPromotionTimeText, promotionTimeText, isEnd, emit, computedButtonText, bannerImage, onClickButton, Button }
}

})